document.addEventListener("DOMContentLoaded", function () {
  const MOBILE_MAX = 767;

  function equalizeBannerTextWrapperHeights() {
    const isMobile = window.innerWidth < MOBILE_MAX;
    const root = document.querySelector(".homepage_banners");
    if (!root) return;

    const wrappers = Array.from(
      root.querySelectorAll(".slideshow__text-wrapper")
    );
    if (!wrappers.length) return;

    /* Reset heights first */
    wrappers.forEach(el => {
      el.style.height = "";
      el.style.minHeight = "";
    });

    if (!isMobile) return;

    /* Calculate max height */
    let maxHeight = 0;
    wrappers.forEach(el => {
      const h = el.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    /* Apply max height to all */
    wrappers.forEach(el => {
      el.style.minHeight = maxHeight + "px";
    });
  }

  /* Run initially */
  requestAnimationFrame(() => {
    equalizeBannerTextWrapperHeights();
    setTimeout(equalizeBannerTextWrapperHeights, 150);
  });

  /* Recalculate on resize & orientation change */
  window.addEventListener("resize", equalizeBannerTextWrapperHeights);
  window.addEventListener("orientationchange", equalizeBannerTextWrapperHeights);

  /* Observe dynamic content changes (fonts, text, slide changes) */
  if ("ResizeObserver" in window) {
    const root = document.querySelector(".homepage_banners");
    if (root) {
      const observer = new ResizeObserver(() => {
        equalizeBannerTextWrapperHeights();
      });

      root
        .querySelectorAll(".slideshow__text-wrapper")
        .forEach(el => observer.observe(el));
    }
  }
});
